import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/ServicesSection.css'; // Create a CSS file for custom styles

interface Industry {
    title: string;
    description: string;
    image: string;
}



const industries :Industry[]  = [
    {
        title: 'Call Centers',
        description: 'Automate call logs & summaries.',
        image: 'CallCenters.jpg',
    },
    {
        title: 'Education',
        description: 'Transcribe lectures & webinars.',
        image: 'Education.jpg',
    },
    {
        title: 'Media & Podcasts',
        description: 'Turn interviews into articles.',
        image: 'MediaPodcasts.jpg',
    },
    {
        title: 'Healthcare',
        description: 'Secure transcription for medical notes.',
        image: 'Healthcare.jpg',
    },
    {
        title: 'Legal & Compliance',
        description: 'Record & document conversations.',
        image: 'LegalCompliance.jpg',
    },
];

const Industries: React.FC = () => {
    return (
        <Container fluid className="services-section" >
            <h1 className="text-center mb-4">Built for Every Industry</h1>
            <Row>
                {industries.map((service, index) => (
                    <Col md={4} key={index} className="mb-4">
                        <div className="service-card">
                            <img src={service.image} alt={service.title} className="img-fluid" />
                            <div className="overlay">
                                <h2>{service.title}</h2>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};


export default Industries;
